import React, { useState } from "react";
import PDFViewer from "./PdfViewer"; // ✅ using your existing viewer component
import CustomCheckbox from "../../UIComponents/customCheckBox/customCheckBox";
import CTAButtton from "../../UIComponents/CTAButton";
import CTAButtton2 from "../../UIComponents/CTAButton2";
import OfferButton from "../../UIComponents/button";

const KFSReviewPage = () => {
  const [selectedDoc, setSelectedDoc] = useState("kfs");
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  // ✅ Replace these URLs with your actual file URLs or blob paths
  const pdfFiles = {
    kfs: "https://ontheline.trincoll.edu/images/bookdown/sample-local-pdf.pdf",
    loan: "https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf",
  };

  return (
    <div className="min-h-[100dvh] w-full max-w-[420px] mx-auto bg-[#FAFAFA] flex flex-col px-2 font-sans">
      {/* Logos */}
      <header className="flex justify-between items-center px-3 py-3 ">
        <img
          src="/assets/img/Footer logo.png"
          alt="digitmoney logo"
          className="h-[17px] w-[100px]"
        />
        <img
          src="/assets/img/26eb0b04408e6ef6d2c5d418d5c6330581462b0a.png"
          alt="fatakpay logo"
          className=" w-[97px]"
        />
      </header>

      {/* Title */}
      <div className="flex items-center justify-center my-3 px-3">
        <hr className="flex-grow border-gray-300" />
        <h2 className="px-3 text-gray-800 font-atkinson-bold text-[20px]">
          KFS & Loan Agreement
        </h2>
        <hr className="flex-grow border-gray-300" />
      </div>

      {/* Toggle Buttons */}
      <div className="flex justify-center flex-wrap gap-2 mb-3 font-atkinson">
        <button
          onClick={() => setSelectedDoc("kfs")}
          className={`px-3 py-2 sm:py-2.5 w-[165px] xs:w-[130px] text-[13px] xs:text-[10px] rounded-[5px] transition ${
            selectedDoc === "kfs"
              ? "bg-black text-white"
              : "bg-white border-[1px] border-gray-500 text-gray-700"
          }`}
        >
          Key Fact Statement
        </button>

        <button
          onClick={() => setSelectedDoc("loan")}
          className={`px-3 py-2 sm:py-2.5 w-[165px] xs:w-[130px] text-[13px] xs:text-[10px] rounded-[5px] transition ${
            selectedDoc === "loan"
              ? "bg-black text-white"
              : "bg-white border-[1px] border-gray-500 text-gray-700"
          }`}
        >
          Loan Agreement
        </button>
      </div>

      {/* PDF Viewer */}
      <div className="border rounded-lg bg-white flex items-center justify-center overflow-hidden h-[60vh] mb-3">
        <PDFViewer kfsUrl={pdfFiles[selectedDoc]} />
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center items-center gap-1 mb-3">
        {["kfs", "loan"].map((doc) => (
          <span
            key={doc}
            onClick={()=>{
              setSelectedDoc(doc)
            }}
            className={`h-2 rounded-full transition-all duration-300 ease-in-out transform ${
              selectedDoc === doc
                ? "w-6 bg-black scale-110"
                : "w-2 bg-white border-[1px] border-black scale-100 cursor-pointer"
            }`}
          ></span>
        ))}
      </div>

      {/* Checkboxes */}
      <div className="space-y-5 mb-4 text-sm text-[#818181] leading-[14px] font-atkinson px-3">
        <label className="flex items-center justify-center gap-2">
          <CustomCheckbox checked={isChecked1} setchecked={setIsChecked1} />
          <span>
            I confirm that the information given is in the language I understand
          </span>
        </label>

        <label className="flex items-center justify-center gap-2">
          <CustomCheckbox checked={isChecked2} setchecked={setIsChecked2} />
          <span>
            I confirm that I have read and understood the information in my key
            fact statement & loan agreement.
          </span>
        </label>
      </div>

      {/* Buttons */}
      <div className="flex w-full">
        <div className="flex-[35%] px-1 pb-3">
          <CTAButtton2 text={"Agree"} className="xs:text-xs" />
        </div>

        <div className="flex-[55%] px-1 pb-3">
         <OfferButton/>
        </div>
      </div>
    </div>
  );
};

export default KFSReviewPage;
